import React from 'react';
import { FormattedMessage } from 'react-intl';

import { isEqual } from 'lodash';

import utils from '../../../../../utils/utilities';
import commonApi from '../../../../../api/Common.api';
import xhr from '../../../../../utils/xhr';

import api from '../../Dashboard.api';

import TrendingTerm from './SingleTrendingTerm';

import { DASHBOARD_PODS_ENTRIES_NUMBER } from './../../../../../constants';

import { findIndex } from 'lodash';

class TrendingTermsPod extends React.Component {
    static defaultProps = {
        backRoute: null
    }

    constructor(props) {
        super(props);

        this.state = {
            terms:                  [],
            pguidOverlayId:         null,
            loading:                true
        };

        this.loadData = this.loadData.bind(this);
        this.getFilterMessageId = this.getFilterMessageId.bind(this);
        this.getCurrentOverlayTerm = this.getCurrentOverlayTerm.bind(this);
    }

    componentWillMount() {
        this.loadData(this.props.days, this.props.entities, this.props.pestle, this.props.risk, this.props.language);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.days !== nextProps.days ||
            !isEqual(this.props.pestle, nextProps.pestle) ||
            !isEqual(this.props.entities, nextProps.entities) ||
            !isEqual(this.props.language, nextProps.language) ||
            !isEqual(this.props.risk, nextProps.risk)) {
            this.loadData(nextProps.days, nextProps.entities, nextProps.pestle, nextProps.risk, nextProps.language);
        }
    }

    loadData(days, entities, pestle, risk, language) {
        this.setState({loading: true});

        let catFilter = utils.buildDashboardFilter(entities, risk, pestle, days, language);
        if (this.props.riskEntityId) {
            catFilter.entities = [this.props.riskEntityId];
        }

        return api
            .getTrendingTerms(DASHBOARD_PODS_ENTRIES_NUMBER, catFilter)
            .then((response) => {
                this.setState({terms: response});
            })
            .then(() => {
                let pguids = [];
                for (let i = 0; i < this.state.terms.length; i++) {
                    pguids.push(this.state.terms[i].indexTermPGUID);
                }
                return commonApi.getPguidDescriptions(pguids);
            })
            .then(() => {
                this.setState({loading: false});
            })
            .catch((error) => {
                utils.logError(error, 'TermsVolumePod.getTrendingTerms():');
                this.setState({loading: false});
                xhr.handleAllErrors(error);
            });
    };

    getFilters() {
        let catFilter = utils.buildDashboardFilter(this.props.entities, this.props.risk, this.props.pestle, this.props.days, this.props.language);
        if (this.props.riskEntityId) {
            catFilter.entities = [this.props.riskEntityId];
        }
        return catFilter;
    }

    getFilterMessageId() {
        switch (this.props.days.toString()) {
            case '1':
                return 'Dashboard_Charts_UIText_dashboard.termsPod.filter1Day';
            case '7':
                return 'Dashboard_Charts_UIText_dashboard.termsPod.filter7Days';
            default:
                return 'Dashboard_Charts_UIText_dashboard.termsPod.filter30Days';
        }
    };

    getFilterMessageIdOverlay() {
        switch (this.props.days.toString()) {
            case '1':
                return 'Dashboard_Charts_UIText_dashboard.podOverlay.filter1Day';
            case '7':
                return 'Dashboard_Charts_UIText_dashboard.podOverlay.filter7Days';
            default:
                return 'Dashboard_Charts_UIText_dashboard.podOverlay.filter30Days';
        }
    };

    getCurrentOverlayTerm() {
        return findIndex(this.state.terms, ['indexTermPGUID', this.state.pguidOverlayId]);
    };

    render() {

        return (

            <div className="dashboard-page__trending--terms">
                <div className="terms-title">
                    {this.props.companyTitle ? this.props.companyTitle + ': ' : null} <FormattedMessage
                    id={this.getFilterMessageId()} />
                </div>
                {
                    this.state.loading ? <div className="temporary-loading-spinner"></div> :
                        <div className="terms-body">
                            {
                                this.state.terms && this.state.terms.length > 0 ?
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="terms-body__terms">
                                                    <FormattedMessage id="General_CoreFunctionality_UIText_terms" />
                                                </th>
                                                <th className="terms-body__articles-number">
                                                    <FormattedMessage id="Dashboard_Charts_UIText_dashboard.articles" />
                                                </th>
                                                <th className="terms-body__risk-angles-levels">
                                                    <FormattedMessage
                                                        id="General_CoreFunctionality_UIText_riskAngleLevels" />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.terms.map(term =>
                                                    <TrendingTerm
                                                        key={'trending-term-' + term.indexTermPGUID + '-' + term.pestle}
                                                        term={term}
                                                        filters={this.getFilters()}
                                                        backRoute={this.props.backRoute}/>)
                                            }
                                        </tbody>
                                    </table>
                                    :
                                    <div className="empty-terms">
                                        <FormattedMessage
                                            id="General_CoreFunctionality_UIText_general.nothingToDisplay" />
                                    </div>
                            }
                        </div>
                }
            </div>
        );
    }

}

export default TrendingTermsPod;


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/TrendingIndexTermPod/TrendingTermsPod.jsx